<div class="document-table">
  <mat-table [dataSource]="documents ?? []" [class.clickable]="!disableRowClick" [trackBy]="trackById">
    <ng-container *ngIf="showPreview" matColumnDef="preview">
      <mat-header-cell *matHeaderCellDef>{{ 'Preview_tr' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document">
        <div class="preview-wrapper">
          @if (getPreview(document); as preview) {
            <img
              class="doc-preview"
              [class.document-preview-pixelated]="isPixelated(document)"
              [alt]="getDisplayTitle(document)"
              [attr.src]="preview"
            />
          } @else if (hasPreviewError(document)) {
            <div class="document-preview-error">
              <mat-icon color="warn">error</mat-icon>
              <span>{{ 'document_preview_error_tr' | translate }}</span>
              <a href="mailto:support@supplycanvas.com" target="_blank" rel="noopener noreferrer">
                <mat-icon>support_agent</mat-icon>
                {{ 'Contact_Support_tr' | translate }}
              </a>
            </div>
          } @else {
            <mat-icon color="primary">insert_drive_file</mat-icon>
          }
        </div>
        <div class="mobile-info">
          <div class="mobile-title">{{ getDisplayTitle(document) }}</div>
          <div class="mobile-type">
            {{ document.type?.name }}
          </div>
          <app-document-review-badge [status]="document.status" [documentDate]="document.date"></app-document-review-badge>
          @if (nameExtra?.template; as template) {
            <ng-container
              [ngTemplateOutlet]="template"
              [ngTemplateOutletContext]="{ $implicit: document, document: document }"
            ></ng-container>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-container *ngIf="showTypeColumn" matColumnDef="type">
      <mat-header-cell *matHeaderCellDef>{{ typeColumnLabel | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document">
        {{ document.type?.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ nameColumnLabel | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document">
        <div>
          <div>{{ getDisplayTitle(document) }}</div>
          <div class="doc-type" *ngIf="!showTypeColumn">
            {{ document.type?.name }}
          </div>
          <div class="doc-type-mobile">
            {{ document.type?.name }}
          </div>
          <app-document-review-badge [status]="document.status" [documentDate]="document.date"></app-document-review-badge>
          @if (nameExtra?.template; as template) {
            <ng-container
              [ngTemplateOutlet]="template"
              [ngTemplateOutletContext]="{ $implicit: document, document: document }"
            ></ng-container>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-container *ngIf="showPages" matColumnDef="pages">
      <mat-header-cell *matHeaderCellDef>{{ 'pages_tr' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let document">{{ document.pages }}</mat-cell>
    </ng-container>

    <ng-container *ngIf="showDelete || actionButtons" matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let document">
        <div class="actions">
          @if (actionButtons?.template; as template) {
            <ng-container
              [ngTemplateOutlet]="template"
              [ngTemplateOutletContext]="{ $implicit: document, document: document }"
            ></ng-container>
          }
          @if (showDelete) {
            <button type="button" mat-icon-button (click)="onDelete(document, $event)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="canClickRow(row) && onRowClick(row)"
      [class.document-row]="!disableRowClick && canClickRow(row)"
    ></mat-row>
  </mat-table>

  @if (otherCustomization?.template; as customization) {
    <ng-container [ngTemplateOutlet]="customization"></ng-container>
  }
</div>
